/**
 * Gotowość 21.10: który integrator obsługuje kanał zlecenia i zbiorczy stan „Zapisu na żywo”.
 * Czyste funkcje (bez Supabase) — testy w integrator.test.js.
 */
export const INTEGRATOR_SYSTEMS = ['baselinker', 'sellasist'];
/** Platformy, które MAMS publikuje bezpośrednio (karta „Publikacja na …” w Gotowości). */
export const DIRECT_PLATFORMS = ['amazon', 'allegro', 'kaufland'];
export function channelIntegrator(ch, conns) {
  const list = conns || [];
  const integ = list.filter(c => INTEGRATOR_SYSTEMS.includes(c.system));
  const legacy = () => (!list.some(c => c.system === 'kaufland') && integ.length === 1 ? integ[0].system : null);
  if (!ch) return legacy();
  const v = ch.settings?.via_integrator;
  if (v === 'baselinker' || v === 'sellasist') return v;
  const linked = ch.connection_id ? list.find(c => c.id === ch.connection_id) : null;
  if (v === true) return (linked && INTEGRATOR_SYSTEMS.includes(linked.system) ? linked.system : integ[0]?.system) || null;
  if (linked) return INTEGRATOR_SYSTEMS.includes(linked.system) ? linked.system : null;
  if (ch.platform === 'base_channel') return 'baselinker';
  if (ch.platform === 'sellasist_channel') return 'sellasist';
  // Poprawka v13 (24.10, A): platforma z publikacją bezpośrednią (Amazon / Allegro / Kaufland) bez `connection_id`
  // i bez jawnego `via_integrator` = kanał bezpośredni. Wcześniej fallback „jedyne połączenie integratora klienta”
  // przerabiał kanał Amazon u klienta z BaseLinkerem na BASE (karta i kolumna BASE zamiast Amazon).
  if (DIRECT_PLATFORMS.includes(ch.platform)) return null;
  // Inne platformy bez connection_id: klient bez połączenia Kaufland i z jednym integratorem → ten integrator.
  return legacy();
}

/** Stan „Zapisu na żywo” kilku kanałów naraz: włączony tylko, gdy włączony we wszystkich. */
export function aggregateWrites(list) {
  if (!list || !list.length || list.some(w => !w)) return null;
  if (list.length === 1) return list[0];
  const on = list.filter(w => w.writes_enabled).length;
  return {
    writes_enabled: on === list.length,
    partial: on > 0 && on < list.length ? { on, total: list.length } : null,
    total: list.length,
    can_toggle: list.every(w => w.can_toggle),
    killed: list.some(w => w.killed),
    channel_id: list.every(w => w.channel_id) ? list[0].channel_id : null,
    is_admin: list[0].is_admin,
    gpsr_list_enabled: list.some(w => w.gpsr_list_enabled),
  };
}

/** INT-ALLEGRO: kanał zlecenia to Allegro bez integratora → karta „Publikacja na Allegro”. */
export function isAllegroDirect(ch, conns) {
  return !!ch && ch.platform === 'allegro' && channelIntegrator(ch, conns) === null;
}

/** Link do oferty Allegro (sandbox albo produkcja). Szkic (nieaktywny) widzi sprzedawca po zalogowaniu. */
export function allegroOfferUrl(env, offerId) {
  if (!offerId) return null;
  return `${env === 'prod' ? 'https://allegro.pl' : 'https://allegro.pl.allegrosandbox.pl'}/oferta/${encodeURIComponent(offerId)}`;
}
